// src/components/GatewayForm.js
import React, { useState, useEffect } from 'react';
import { Box, Button, Input, FormControl, FormLabel, Select, useToast } from '@chakra-ui/react';
import { addGateway } from '../utils/firebase.utils';

const GatewayForm = ({ gateway, onSubmit }) => {
  const [formData, setFormData] = useState({
    id: gateway ? gateway.id : `gateway-${Date.now()}`,
    name: gateway ? gateway.name : '',
    location: gateway ? gateway.location : '',
    status: gateway ? gateway.status : 'Online',
  });
  const toast = useToast();

  useEffect(() => {
    if (gateway) {
      setFormData({
        id: gateway.id,
        name: gateway.name,
        location: gateway.location,
        status: gateway.status,
      });
    }
  }, [gateway]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addGateway(formData);
      toast({
        title: "Gateway saved.",
        description: "The gateway has been successfully saved.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onSubmit();
    } catch (error) {
      toast({
        title: "Error saving gateway.",
        description: "There was an error saving the gateway. Please try again.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit} p={4}>
      <FormControl mb={3}>
        <FormLabel>Gateway Name</FormLabel>
        <Input name="name" value={formData.name} onChange={handleChange} required />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Location</FormLabel>
        <Input name="location" value={formData.location} onChange={handleChange} required />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Status</FormLabel>
        <Select name="status" value={formData.status} onChange={handleChange}>
          <option value="Online">Online</option>
          <option value="Offline">Offline</option>
        </Select>
      </FormControl>
      <Button type="submit" colorScheme="teal">Save Gateway</Button>
    </Box>
  );
};

export default GatewayForm;